import { atom } from 'jotai'

/**
 * 配送依頼 汎用CSVインポート（独自フォーマット・マッピング対応）Modal の表示状態。
 * VOC_PJ-592 #4071。既存の標準インポート（isOpenShipmentOrderImportModalAtom）とは別物。
 */
export const isOpenShipmentOrderCsvImportModalAtom = atom<boolean>(false)

isOpenShipmentOrderCsvImportModalAtom.debugLabel =
  'isOpenShipmentOrderCsvImportModalAtom'
